module.exports = __webpack_public_path__ + "static/media/archive2.be0730e1.jpeg";